export type Lang = 'fr' | 'en';

export type BilingualLax = { fr: string; en: string } | string;

export const DEFAULT_LANG: Lang = 'fr';
export const LANG_STORAGE_KEY = 'oceanne-lang';

export function ta<T extends Record<string, BilingualLax>>(
  dict: T,
  lang: Lang
): { [K in keyof T]: string } {
  const out = {} as { [K in keyof T]: string };
  for (const key in dict) {
    const value = dict[key];
    out[key] = typeof value === 'string' ? value : value[lang];
  }
  return out;
}
